import { ElementRef, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UtilService {
  private scrollTrigger = new Subject<string>();
  scroll$ = this.scrollTrigger.asObservable();

  private imagedata = new BehaviorSubject<string>('');
  img$ = this.imagedata.asObservable();

  private themeSub = new BehaviorSubject<string>('');
  theme$ = this.themeSub.asObservable();

  private _sectionVisibility = new BehaviorSubject<boolean>(true);
  sectionVisibility$ = this._sectionVisibility.asObservable();

  setSectionVisibility(flag:boolean){
    this._sectionVisibility.next(flag)
  }

  heroImage(strImg: string){
    this.imagedata.next(strImg)
  }

  triggerScroll(targetId: string) {
    this.scrollTrigger.next(targetId);
  }

  pushTheme(theme:string){
    this.themeSub.next(theme)
  }

  scrollTo(targetId:string, scrolltarget:ElementRef){
      if (targetId === 'scrollToEvents') {
        const headerOffset = 80; 
        const elementPosition = scrolltarget.nativeElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
  }

  
removeLastAlphabet(str:string):string {
  // Check if last char is an alphabet
  if (/[a-zA-Z]$/.test(str)) {
    return str.slice(0, -1); 
  }
  return str;
}

  
}